export default __webpack_public_path__ + "static/media/onh.79589f41.png";